export const getClientPageIsLoaded = state => state?.page?.isClientPageLoaded ?? false;
